import { useCallback } from 'react';

import {
  capturePostHogEvent,
  registerPostHogProperties
} from '../services/postHogService';

// Returns `onOpened`/`onClosed` callbacks for reactstrap <Modal> wrappers.
// Sets `modal` as a PostHog super-property while open so events fired inside
// the modal (autocapture, manual) carry the modal name alongside the parent
// `screen`. Fires explicit `modal_opened` / `modal_closed` events for funnels.
//
// Passing a falsy `name` makes both callbacks no-ops.
export default function useModalTracking(name) {
  const onOpened = useCallback(() => {
    if (!name) return;
    registerPostHogProperties({ modal: name });
    capturePostHogEvent('modal_opened', { modal: name });
  }, [name]);

  const onClosed = useCallback(() => {
    if (!name) return;
    capturePostHogEvent('modal_closed', { modal: name });
    registerPostHogProperties({ modal: null });
  }, [name]);

  return { onOpened, onClosed };
}
